module.exports = __webpack_public_path__ + "files/3088713fdb8b0a88ea134e19c1338f25.png";